"use strict";
var EmailViewModel = (function () {
    function EmailViewModel() {
        this.email = '';
        this.noEmail = false;
    }
    return EmailViewModel;
}());
exports.EmailViewModel = EmailViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/email-view.model.js